import qs from 'qs'

const fields = [
  'datePosted',
  'highlighted',
  'locale',
  'slug',
  'title',
]

const sort = ['highlighted', 'datePosted:desc', 'title:asc']

const populate = {
  coverImage: '*',
  blocks: {
    ...queryFragmentFirstRichTextBlock
  },
  journalTags: '*'
}

export const queryJournalEntriesThumbnail = (options: QueryManyOptionsi18n) => {
  const query = qs.stringify(
    {
      locale: options?.locale || 'nl-NL',
      pagination: {
        page: options?.page || 1,
        pageSize: options?.pageSize || 9
      },
      filters: {
        journalTags: {
          id: {
            $eq: options?.tagId
          }
        }
      },
      sort: sort,
      fields: fields,
      populate: {
        localizations: {
          sort: sort,
          fields: fields,
          populate: {
            ...populate
          }
        },
        ...populate
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `journal-entries?${query}`
}
